"use client";
import React, { useState } from "react";
import { usePathname } from "next/navigation";
import "./ContactFormWidget.scss";
import ContactForm from "../ContactForm/ContactForm";
import { AiOutlineMessage } from "react-icons/ai";

const ContactFormWidget = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const pathname = usePathname();

  const shouldHideWidget =
    pathname.includes("/11-11") ||
    pathname.includes("/cart") ||
    pathname.includes("/checkout") ||
    pathname.includes("/b2b-payments");

  const toggleForm = () => {
    setIsFormOpen(!isFormOpen);
    // When opening the form, prevent body scrolling
    if (!isFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  };

  // If widget should be hidden, don't render anything
  if (shouldHideWidget) {
    return null;
  }

  return (
    <>
      <div className="contact-form-widget">
        <button
          className="contact-form-button"
          onClick={toggleForm}
          aria-label="Open contact form"
          title="Contact Us"
        >
          <AiOutlineMessage size={24} />
        </button>
      </div>

      {isFormOpen && (
        <div className="contact-form-overlay" onClick={toggleForm}>
          <div
            className="contact-form-container open"
            onClick={(e) => e.stopPropagation()}
          >
            <ContactForm onClose={toggleForm} backgroundColor="#D62314" />
          </div>
        </div>
      )}
    </>
  );
};

export default ContactFormWidget;
